function formatDateForInput(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function getMinBookingDate() {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return formatDateForInput(tomorrow);
}

const bookingHoursByWeekday = {
  0: null,
  1: null,
  2: { min: '10:00', max: '18:00' },
  3: { min: '10:00', max: '18:00' },
  4: { min: '10:00', max: '19:00' },
  5: { min: '10:00', max: '19:00' },
  6: { min: '10:00', max: '16:00' },
};

export function getBookingHours(dateString) {
  if (!dateString) {
    return null;
  }

  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);

  if (
    Number.isNaN(date.getTime()) ||
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return bookingHoursByWeekday[date.getDay()];
}

export function isTimeWithinBookingHours(time, hours) {
  return Boolean(time && hours && time >= hours.min && time <= hours.max);
}

export function isLikelyBot({ honeypot, formStartedAt }) {
  const filledHiddenField = Boolean(honeypot && honeypot.trim().length > 0);
  const submittedTooFast = Date.now() - formStartedAt < 4000;
  return filledHiddenField || submittedTooFast;
}
